import React, { useState } from "react";
import { Icons } from "../../components/common/Icons";
import { useInternData } from "../../context/InternContext";
import T from '../../assets/styles/theme';
import "../../assets/styles/Intern/CertificateSection.css";

function CertificateSection() {
  const { internData } = useInternData();
  const [downloading, setDownloading] = useState(false);

  // Dynamic: check if internship end date has passed
  const now = new Date();
  const endDate = internData.endDate ? new Date(internData.endDate) : null;
  const startDate = internData.startDate ? new Date(internData.startDate) : null;
  const endReady = endDate && !Number.isNaN(endDate.getTime())
    ? new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59, 59, 999)
    : null;
  const ok = endReady ? now >= endReady : false;

  // Calculate progress from dates
  let progress = 0;
  if (startDate && endDate && endDate > startDate) {
    const total = endDate.getTime() - startDate.getTime();
    const elapsed = Math.min(now.getTime() - startDate.getTime(), total);
    progress = Math.max(0, Math.min(100, Math.round(elapsed / total * 100)));
  }

  const fmtDate = (d) => d ? new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'long', year: 'numeric' }) : '';

  const handleDownload = async () => {
    if (!ok || downloading) return;
    try {
      setDownloading(true);
      const api = (await import("../../services/api")).default;
      const filename = `Internship_Certificate_${(internData.name || 'intern').replace(/\s+/g, '_')}.html`;
      await api.downloadInternCertificate(filename);
    } catch (e) {
      alert('Certificate download failed: ' + (e.message || 'Unknown error'));
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="card animate-in delay-6">
      <div className="card-body cert-card">
        <div className={`cert-icon ${ok ? "unlocked" : "locked"}`}>
          {ok ? <Icons.Certificate /> : <Icons.Lock />}
        </div>
        <div className="cert-status">{ok ? "Certificate Available!" : "Certificate Locked"}</div>
        <div className="cert-desc">
          {ok ?
          "Congratulations! Your internship certificate is ready for download." :
          endDate ?
          `Complete your internship by ${fmtDate(internData.endDate)} to unlock. You're ${progress}% through!` :
          `Complete your internship to unlock. Progress: ${progress}%`
          }
        </div>
        <button className="btn-primary" disabled={!ok || downloading} onClick={handleDownload}>
          <Icons.Download />{downloading ? "Preparing..." : ok ? "Download Certificate" : "Locked - Complete Internship"}
        </button>
        {!ok &&
        <div className="certificatesection-inline-1">
            <div style={{ "--certificatesection-1-background": T.border }} className="certificatesection-dyn-1">
              <div style={{ "--certificatesection-2-width": `${progress}%` }} className="certificatesection-dyn-2" />
            </div>
            <div className="certificatesection-inline-2">{progress}% completed</div>
          </div>
        }
      </div>
    </div>);

}

export default CertificateSection;
